import GENERAL_REGEX from './regex';

export default function convertRialToToman(price, percent, calculate = false) {
	if (!price && undefined && NaN) return '0';
	const standardPrice = Number(
		price.toString().replace(GENERAL_REGEX.removeComma.pattern, '')
	);
	const percentage = (standardPrice * percent) / 100;
	const result = calculate ? percentage : standardPrice;

	return Math.trunc(result / 10).toLocaleString();
}
